import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectVersionBanner } from '../../store/ui/ui.selector';

import CloseBtn from '../close-btn/close-btn.component';

import './recent-updates.styles.scss';
import { Typography } from '@mui/material';
import { changeShowRecentUpdates } from '../../store/ui/ui.slice';


// New feature list format:
// {
//   title: '',
//   description: '',
//   imgSrc: '',
//   imgAlt: ''
// }
const newFeatures = [{
  title: '2025 Hazard Events',
  description: 'The database has been updated to include events reported for 2025 in the NCEI Storm Events Database.',
  imgSrc: '',
  imgAlt: ''
},{
  title: 'Hurricane API Data',
  description: "The new data can be found by selecting the 'Tropical Storms/Hurricanes' theme and, with the chart open, clicking 'Use Hurricane API Data'.",
  imgSrc: 'seeHurricaneApiData.png',
  imgAlt: 'Image indicating how to view alternative hurricane data'
},{
  title: 'LOCA2 Projected Climate Data',
  description: 'The projected climate data that is displayed is now using the new LOCA2 data source instead of LOCA. Check it out by selecting a climate data variable, clicking on a state or county, then choosing the "High Emissions" or "Low Emissions" tab in the chart display.',
  imgSrc: '',
  imgAlt: ''
},{
  title: 'Weather Station Climate Data',
  description: 'Weather station icons can be seen when zoomed in with any climate hazard selected. By clicking an icon you can see historical and projected climate data in the chart view.',
  imgSrc: '',
  imgAlt: ''
},{
  title: 'This feature!',
  description: "When new features are added, this feature will pop up the next time you visit to let you know. Once you close this box it will not appear again, but you can see recent changes in the 'Recent Tool Changes' section of the help menu.",
  imgSrc: 'seeRecentToolChanges.png',
  imgAlt: 'Image indicating where to look for Recent Tool Changes section in Help menu'
}];

export default function RecentUpdates() {
  const { number } = useSelector(selectVersionBanner);
  const dispatch = useDispatch();

  return (
    <div className='recent-updates-container'>
      <div className='recent-updates-content'>
        <div className='recent-updates-title-container'>
          <Typography variant='h5' sx={{ lineHeight: 1.1 }}>What&apos;s new?</Typography>
          <Typography variant='subtitle2' sx={{ lineHeight: 1.1, fontStyle: 'italic', color: 'rgb(150,150,150)' }}>Version {number}</Typography>
        </div>

        <CloseBtn handleClose={() => dispatch(changeShowRecentUpdates(false))} />

        <div className='recent-updates-feature-list-container'>
          <ul className='recent-updates-feature-list'>
            {newFeatures.map((feat, i) => (
              <li key={i} className='recent-updates-feature-list-item'>
                <div className='recent-updates-feature-list-item-title'>{feat.title}</div>
                <div className='recent-updates-feature-list-item-description'>{feat.description}</div>
                {feat.imgSrc && <div className='recent-updates-feature-list-item-picture'><img src={`${process.env.PUBLIC_URL}/updates-images/${feat.imgSrc}`} alt={feat.imgAlt} /></div>}
              </li>
            ))}
          </ul>
        </div>
        
        <div className='list-inlay' />
      </div>
    </div>
  );
}